import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { Angulartics2Module } from 'angulartics2';
import { PlatformModule} from "../platform/platform.module";
import { GalleryModule } from  '@ngx-gallery/core';
import { LightboxModule } from  '@ngx-gallery/lightbox';
import { GallerizeModule } from  '@ngx-gallery/gallerize';


import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { HomeComponent } from './home/home.component';
import { KeyArtComponent} from "./key-art/key-art.component";
import { RacesComponent} from "./races/races.component";
import { FeaturesComponent} from "./features/features.component";
import { MediaComponent} from "./media/media.component";
import { ScreenshotsComponent} from "./media/screenshots.component";
import { ConceptArtComponent} from "./media/concept-art.component";
import { RegisterComponent } from "./register/register.component";
import {AccountModule} from "../account/account.module";
import {SectionComponent} from "./section/section.component";
import {MailchimpModule} from "../mailchimp/mailchimp.module";
import {SubscriptionConfirmedComponent} from "./subscription/subscription-confirmed.component";
import {SubscriptionNeedsConfirmationComponent} from "./subscription/subscription-needs-confirmation.component";
import {ImprintComponent} from "./imprint/imprint.component";
import {ParticlesComponent} from "./particles/particles.component";
import {DownloadComponent} from "./download/download.component";

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
      Angulartics2Module,
      GalleryModule.withConfig({
        thumb: false,
        imageSize: 'contain',
        dots: true,
        loop: true,
        counter: false
    }),
    LightboxModule.withConfig({
        panelClass: 'fullscreen'
    }),
    GallerizeModule,
   AccountModule,
   PlatformModule,
   MailchimpModule,
  ],
  declarations: [HeaderComponent, FooterComponent, HomeComponent, KeyArtComponent, RacesComponent, FeaturesComponent, MediaComponent, ScreenshotsComponent, ConceptArtComponent, RegisterComponent, SectionComponent, SubscriptionConfirmedComponent, SubscriptionNeedsConfirmationComponent, ImprintComponent, ParticlesComponent, DownloadComponent],
  exports: [HeaderComponent, FooterComponent]
})
export class UiModule { }
